/** @license ISC License (c) copyright 2017 original and current authors */
/** @author Ian Hofmann-Hicks (evil) */

var unsetProp = require('./unsetProp')

module.exports =
  unsetProp.origFn('dissoc')
